var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87963 0.980957C2.64669 0.980957 0.000732422 3.62685 0.000732422 6.85984V25.103C0.000732422 28.336 2.64663 30.981 5.87963 30.981H24.1228C27.3559 30.981 30.0009 28.3361 30.0009 25.103V6.85984C30.0009 3.62692 27.3559 0.980957 24.1228 0.980957H5.87963ZM7.35825 5.93157C8.90838 5.93157 9.86318 6.9492 9.89266 8.28685C9.89266 9.59498 8.90831 10.6412 7.32827 10.6412H7.29919C5.77857 10.6412 4.79572 9.59504 4.79572 8.28685C4.79572 6.94923 5.80832 5.93157 7.35823 5.93157H7.35825ZM20.7165 12.1836C23.6978 12.1836 25.9326 14.1321 25.9326 18.3194V26.1363H21.402V18.8435C21.402 17.0108 20.7463 15.7606 19.1066 15.7606C17.8551 15.7606 17.1089 16.6033 16.7814 17.4173C16.6617 17.7086 16.6324 18.1155 16.6324 18.5228V26.1363H12.1017C12.1017 26.1363 12.1612 13.7824 12.1017 12.5033H16.6332V14.4339C17.2353 13.5049 18.3123 12.1836 20.7165 12.1836V12.1836ZM5.06296 12.5043H9.59355V26.1363H5.06296V12.5043Z",
    fill: "#0A0F16"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8a4410446fa6d45fea0e6222d27d66a3.svg";
export { ForwardRef as ReactComponent };